var _defs, _path, _path2, _line, _line2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shieldGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glowGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7dd3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0ea5e9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 5 L 90 20 C 90 60 70 85 50 95 C 30 85 10 60 10 20 Z",
    fill: "none",
    stroke: "url(#shieldGrad)",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 14 L 80 25 C 80 55 65 75 50 84 C 35 75 20 55 20 25 Z",
    fill: "rgba(56, 189, 248, 0.15)",
    stroke: "url(#glowGrad)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 14,
    x2: 50,
    y2: 84,
    stroke: "#e0f2fe",
    strokeWidth: 1.5,
    opacity: 0.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 55,
    x2: 80,
    y2: 55,
    stroke: "#e0f2fe",
    strokeWidth: 1.5,
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 14 L 80 55 L 50 84 L 20 55 Z",
    fill: "none",
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 35 L 72 55 L 50 72 L 28 55 Z",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 2,
    opacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0ea7e52fe0e4f32da8f554228f34760.svg";
export { ForwardRef as ReactComponent };